var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastFoodOutlined = function SvgFastFoodOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fastFoodOutlined_svg__a)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15.083 18.333c0 1.473-.86 2.667-2.333 2.667h-5.5c-1.473 0-2.333-1.194-2.333-2.667M15.667 15c.736 0 1.333.746 1.333 1.667 0 .92-.597 1.666-1.333 1.666H4.333c-.736 0-1.333-.746-1.333-1.666S3.597 15 4.333 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fastFoodOutlined_svg__b)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.334 12.448v-.009c0-2.162 1.875-3.294 4.167-3.294h3c2.292 0 4.167 1.14 4.167 3.303v-.009M11.709 6l.31 2.515m3.982 6.292H9.139a.34.34 0 0 0-.236.092l-1.118 1.055a.17.17 0 0 1-.118.046.18.18 0 0 1-.117-.046l-1.118-1.055a.34.34 0 0 0-.236-.092H4.001c-.265 0-.52-.1-.707-.276A.92.92 0 0 1 3 13.863c0-.25-.031-.79.293-1.087A.98.98 0 0 1 4 12.5h12a.98.98 0 0 1 .707.276c.324.298.293.837.293 1.087s-.106.49-.293.668a1.03 1.03 0 0 1-.707.276Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fastFoodOutlined_svg__c)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M12 21h5.384c.312 0 .612-.124.841-.348s.369-.53.392-.859L20 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fastFoodOutlined_svg__d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m17 6 .508-2.4L19 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fastFoodOutlined_svg__e)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M11 6h10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fastFoodOutlined_svg__a",
    x1: 3.299,
    x2: 16.449,
    y1: 21,
    y2: 19.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6195EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fastFoodOutlined_svg__b",
    x1: 3.299,
    x2: 16.52,
    y1: 16,
    y2: 15.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6195EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fastFoodOutlined_svg__c",
    x1: 12.171,
    x2: 19.744,
    y1: 21,
    y2: 20.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6195EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fastFoodOutlined_svg__d",
    x1: 17.043,
    x2: 18.936,
    y1: 6,
    y2: 5.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6195EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fastFoodOutlined_svg__e",
    x1: 11.213,
    x2: 19.431,
    y1: 7,
    y2: 3.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6195EB"
  })))));
};
export default SvgFastFoodOutlined;